/* istanbul ignore file */
import { updateUserInfo } from "../reducers/userInfoSlice";
import { store } from "../store";
import { notifyApiFail } from "../reducers/errorNotifySlice";
import { customAxios } from "./serviceInterceptor";
import { getAPIPath } from "../utils/endPointMapper";
import { getHeaders } from "../utils/getUsersDetails";
import { systemAlertFunc } from "./auth.service";
import { setSectionFailKey } from "../reducers/commonSlice";
import { submitSkipTradingInfo } from "./auTradingInfo.service";

const API_URL = getAPIPath().REACT_APP_BASE_URL;
export const userInfoData =
	(sectionResponse, requestObject, mandatoryData) => async (dispatch) => {
		const state = store.getState();
		const users = [];
		if (sectionResponse?.serviceName === "tob") {
			requestObject["esmaWarning"] = state.signUp.esmaText;
		}
		if (mandatoryData !== undefined || mandatoryData !== null) {
			requestObject["mandatoryFields"] = mandatoryData
		}
		users.push(requestObject);
		const requestBody = {
			users: users,
		};
		const requestObj = {
			processName: "updateUser",
			requestBody,
			methodType: "POST",
		};
		if (sectionResponse?.serviceName) {
			requestObj.serviceName = [sectionResponse?.serviceName];
		}
		const config = {
			...getHeaders(state?.signUp?.authToken, state?.user?.user)
		};
		return await customAxios
			.post(API_URL, requestObj, config)
			.then((response) => {
				if (response?.data?.success) {
					if (sectionResponse?.serviceName === "financialInfo" && state?.signUp?.userEntity === "FXCM_AU") {
						submitSkipTradingInfo(config);
					}
					dispatch(updateUserInfo(sectionResponse));
					if (sectionResponse?.serviceName === "hrin") {
						if (!requestObject.hrinStatus) {
							dispatch(updateUserInfo({ triggerLogout: true }))
						}
					}
				} else {
					const statusCode = response?.data?.httpStatus ?? response?.status;
					let message =
						response.data && response.data.message
							? response.data.message
							: "Something went wrong.";
					dispatch(notifyApiFail(message));
					dispatch(systemAlertFunc(config?.headers?.requestid, statusCode, response?.data?.message ?? response?.message));
				}
			})
			.catch((err) => {
				const validationError = err?.response?.data?.validationErrorMap
				if (err?.response?.data?.status == 400 && Object.values(validationError)?.length) {
					const validationKey = [...new Set(Object.values(validationError))][0];
					let errorMessage = "VALIDATION_INVALID_CHARACTERS";
					switch (validationKey) {
						case "VALIDATION_TOO_LONG":
							errorMessage = "VALIDATION_TOO_LONG"
							break;
						case "VALIDATION_NAME_INVALID":
							errorMessage = "CHARACTERS_ONLY"
							break;
						case "VALIDATION_ADDRESS_INVALID":
							errorMessage = "SPECIAL_CHARACTER"
							break;
						case "VALIDATION_PHONE_INVALID":
							errorMessage = "CONTACT_NUMBER_LENGTH_ERROR"
							break;
						default:
							errorMessage = "VALIDATION_INVALID_CHARACTERS"
							break;
					}
					dispatch(setSectionFailKey(errorMessage));
				} else {
					if (err?.response?.data?.message === "USER_PKA_FAILURE" && state?.signUp?.userEntity === "FXCM_UK") {
						window.location.reload();
					}
					const statusCode = err?.response?.data?.httpStatus ?? err?.response?.status;
					const message = err?.response?.data?.message ?? err?.response?.message;
					dispatch(notifyApiFail("SOMETHING_WENT_WRONG"));
					dispatch(systemAlertFunc(config?.headers?.requestid, statusCode, message));
				}
			});
	};
